import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { AIResponse } from '@app-velocity/common';

export type AiResponseSummaryProps = {
  response: AIResponse;
  variant?: 'compact' | 'default';
  onClick?: () => void;
  endAdornment?: ReactNode;
};

const StyledSummary = styled('p', {
  shouldForwardProp: (prop) => prop !== 'interactive' && prop !== 'variant',
})<{ interactive?: boolean; variant?: 'compact' | 'default' }>(
  ({ theme, interactive, variant }) => ({
    fontSize: variant === 'compact' ? 12 : 14,
    fontWeight: 600,
    margin: 0,
    ...(interactive
      ? {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: theme.spacing(2),
          cursor: 'pointer',
        }
      : {}),
  })
);

export const AiResponseSummary = ({
  response,
  onClick,

  endAdornment,
  variant = 'default',
}: AiResponseSummaryProps) => {
  const text = response.finished
    ? response.finishedExplanation
    : response.nextStep;

  return (
    <StyledSummary
      interactive={!!onClick}
      onClick={onClick}
      variant={variant}
      role={onClick ? 'button' : undefined}
    >
      <span>{text}</span>
      {endAdornment}
    </StyledSummary>
  );
};
